import { useMutation, useQueryClient } from "react-query";
import { useRecoilState } from "recoil";
import { editCarrierProgram } from "../../../../../actions/Utilities/CarrierProgram";
import { toast } from "../../../../../components/toastNotification";
import { editStateCarrierProgram } from "../atoms/atoms";
const useEditCarrierProgram = () => {
  const queryClient = useQueryClient();
  const [, setEditState] = useRecoilState(editStateCarrierProgram);
  const { mutate } = useMutation(
    (updatedProd) => editCarrierProgram({ ...updatedProd }),
    {
      onSuccess: (res) => {
        if (res.data === "duplicate") {
          toast.fire(
            "Failed",
            "Another Carrier Program already has the same information",
            "error"
          );
        } else if (res.status === 201) {
          setEditState(false);
          toast.fire(
            "Success",
            "Carrier Program updated successfully",
            "success"
          );
          queryClient.invalidateQueries();
        } else {
          toast.fire(
            "Failed",
            "Server Error: Cannot update Carrier Program",
            "error"
          );
        }
      },
      onError: (error) => {
        if (
          error.response.data.message === "Failed sending of email" ||
          error.response.data.message === "Failed inserting of notification"
        ) {
          toast.fire(
            "Success",
            "Carrier Program updated successfully, but " +
              error.response.data.message,
            "warning"
          );
          queryClient.invalidateQueries();
        } else {
          toast.fire(
            "Failed",
            "Server Error: Cannot add new Carrier Program",
            "error"
          );
        }
      },
    }
  );

  return mutate;
};
export default useEditCarrierProgram;
